import * as React from 'react'

import { cn } from '../../lib/utils'

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn(
        'gap-0.5 text-sm leading-none text-foreground font-medium group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed font-sans',
        className,
      )}
      {...props}
    />
  )
}

export { Label }
